import { useSyncExternalStore } from 'react';

// Module-scoped shared state so any component (Header, CondensedHeader,
// CartSidebar login gate, etc.) can open the same login modal.
let isOpen = false;
const listeners = new Set();

const setOpen = (next) => {
  const value = typeof next === 'function' ? next(isOpen) : next;
  if (value === isOpen) return;
  isOpen = value;
  listeners.forEach((fn) => fn());
};

const subscribe = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

const getSnapshot = () => isOpen;

const useLoginModal = () => {
  const currentOpen = useSyncExternalStore(subscribe, getSnapshot);
  return {
    isOpen: currentOpen,
    openLogin: () => setOpen(true),
    closeLogin: () => setOpen(false),
  };
};

export default useLoginModal;
